export const Props = () => ({
  //Всегда открыта вкладка?
  isAlwaysOpened: {
    type: Number,
    required: true,
  },
});